import { ChangeEvent, forwardRef } from "react"
import { RadioButton, RadioGroup as GoRadioGroup } from "@gogoro/go-design"
import classnames from "classnames"

import { RadioGroupProps, RadioOption } from "./RadioGroupProps"

import styles from "./styles.module.scss"

const getOptionType = (options: Array<RadioOption> | null): string => {
  if (options?.length) {
    return typeof options[0].value
  }
  return "string"
}

const stringToBoolean = (stringValue: string | null): boolean => stringValue?.toLowerCase() === "true"

const RadioGroup = (
  { name, options = [], onChange, disabled = false, radioGroupClassName = "", value, ...restProps }: RadioGroupProps,
  ref: any,
) => {
  //  get value type to cast value when onChange fired
  const type = getOptionType(options)

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    let finalValue = null

    if (type === "number") {
      finalValue = Number(value)
    } else if (type === "boolean") {
      finalValue = stringToBoolean(value)
    } else {
      finalValue = value
    }

    onChange && onChange(finalValue, e)
  }

  const formattedValue = typeof value === "boolean" ? String(value) : value

  return (
    <GoRadioGroup name={name} {...restProps} value={formattedValue} onChange={handleOnChange}>
      <div className={classnames(styles["radio-group-container"], radioGroupClassName)}>
        {options?.map(({ label, value, disabled: optionDisabled, ...restProps }: RadioOption, index: number) => {
          const finalValue = type === "boolean" ? String(value) : value
          return (
            <div className={styles["option-container"]} key={index}>
              <RadioButton
                ref={ref}
                label={label}
                value={finalValue as string | number | undefined}
                {...restProps}
                disabled={disabled || optionDisabled}
              />
            </div>
          )
        })}
      </div>
    </GoRadioGroup>
  )
}

export default forwardRef(RadioGroup)
